import { fork } from 'redux-saga/effects';
import { settingsSaga } from './sagas/settings.saga';
import { surveyTrackingSaga } from './sagas/surveyTracking.saga';
import { emailEditingSaga } from './sagas/emailEditing.saga';

export function* settingsMainSaga() {
	yield fork(settingsSaga);
	yield fork(surveyTrackingSaga);
	yield fork(emailEditingSaga);
}
